import ProductRowSkeleton from './ProductRowSkeleton';

export default ProductRowSkeleton;
